import {
  ContrastingColors,
  ThemeValues,
  getBrandAttribute,
  getDefaultThemeForHost,
} from '@/shared/theme/host-theme-config';

export interface ThemePreferences {
  contrastingColors: ContrastingColors;
  theme: ThemeValues;
  showFlags?: boolean;
}

// eslint-disable-next-line
export default {
  setThemeBasedOnUserPreferences(localPreferences: ThemePreferences) {
    const root = document.getElementById('html-root-element');

    if (root) {
      if (localPreferences.contrastingColors)
        root.setAttribute('data-diff-theme', localPreferences.contrastingColors);

      const mode = localPreferences.theme ?? getDefaultThemeForHost();
      root.setAttribute('data-bs-theme', mode);

      const brand = getBrandAttribute();
      if (brand) root.setAttribute('data-brand', brand);
      else root.removeAttribute('data-brand');

      root.setAttribute('data-flag-display', localPreferences.showFlags ? 'images' : 'text');
    }
  },
};
